import React from "react";
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import * as styles from "./RecruitFooter.module.scss"

const RecruitFooter = ({ pageName, ...props }) => {
  return(
    <footer className={`${styles.RecruitFooter}`}>
      <nav className={`${styles.RecruitFooter__pankuzu} Pankuzu`}>
        <ol>
          <li><a href="/">home</a></li>
          <li><a href="/recruit/">採用情報</a></li>
          {
            (pageName === "recruit") ?
            null
            : (pageName === "voice_page") ?
            <>
            <li><a href="/voice/">先輩たちの声一覧</a></li>
            <li><span className={`text-ellipsis em7`}>{props.title}</span></li>
            </>
            :
            <li><span>{props.title}</span></li>

          }
        </ol>
      </nav>
      <div className={`${styles.RecruitFooter__logo}`}>
        <a href="/recruit/">
          <StaticImage
            layout="fullWidth"
            src="../../images/recruit/logo_footer.png"
            alt="logo_footer"
          />
        </a>
      </div>
      <div className={`${styles.RecruitFooter__btm}`}>
        <small>Copyright © FUKAWA YOUKEI All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default RecruitFooter